import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import Button from '../Button';
import breakpoints from '../Theme/breakpoints';

const brandFilterPropertyTypes = {
  children: PropTypes.node.isRequired,
  closeDialog: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

type BrandFilterProperties = InferProps<typeof brandFilterPropertyTypes>;

type BrandFilterOpenProperty = Pick<BrandFilterProperties, 'open'>;

const BrandFilterOverlay = styled.div<BrandFilterOpenProperty>`
  display: ${(properties) => (properties.open ? 'block' : 'none')};
  background-color: var(--black);
  opacity: 0.3;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
`;

const BrandFilterPanel = styled.div<BrandFilterOpenProperty>`
  display: ${(properties) => (properties.open ? 'flex' : 'none')};
  padding: 16px 10px 24px;
  background-color: var(--white);
  z-index: 4;
  position: fixed;
  top: 0;
  overflow-y: scroll;
  left: 50vw;
  transform: translateX(-50%);
  box-sizing: border-box;
  margin: -6px 0 4px 0;
  width: 100vw;
  height: 100vh;

  @media (min-width: ${breakpoints.md}px) {
    max-width: 1000px;
    width: auto;
    height: 80vh;
    margin: 10vh auto;
  }
  
  & h6 {
    position: relative;
    z-index: 6;
    margin: -6px 0 4px 0;

    @media (min-width: ${breakpoints.xssm}px) {
      margin: -14px 0 4px 10px;
    }
  }
  & label {
    max-width: 38vw;
    
    @media (min-width: ${breakpoints.xssm}px) {
      max-width: 400px;
    }
  }
`;

export const OpenDialogButton = styled(Button)`
  margin: 8px auto 0;
  width: fit-content;
  &&& {
    font-size: var(--size-sub1);
  }
`;

const CloseDialogIcon = styled.span<BrandFilterOpenProperty>`
  display: ${(properties) => (properties.open ? 'inline-block' : 'none')};
  font-size: 24px;
  font-weight: bold;
  position: fixed;
  cursor: pointer;
  z-index: 5;
  text-align: right;
  max-width: 1000px;
  left: 50vw;
  transform: translate(0%);
  margin-top: 0;
  right: 12px;
  top: 10px;
  padding-right: 0;

  @media (min-width: ${breakpoints.md}px) {
    transform: translateX(-50%);
    margin-top: 9.4vh;
    right: 8px;
    top: 16px;
    padding-right: 8px;
  }
`;

const BrandFilter = ({
  children,
  open,
  closeDialog,
}: BrandFilterProperties) => (
  <>
    <BrandFilterOverlay
      open={open}
    />
    <CloseDialogIcon
      onClick={closeDialog}
      open={open}
    >
      &#10005;
    </CloseDialogIcon>
    <BrandFilterPanel
      open={open}
      className="more-brands"
    >
      { children }
    </BrandFilterPanel>
  </>
);

BrandFilter.propTypes = brandFilterPropertyTypes;

export default BrandFilter;
